//@flow
export const ShopWebSiteExcludedRoutes = [ '/me', '/cart', '/orders'];
export const MarketplaceExcludedRoutes = [ '/me', '/cart', '/orders'];
export const LocalMarketExcludedRoutes = [ '/me', '/cart', '/orders'];
export const SellerMgmtExcludedRoutes = [ '/', '/me', '/products', '/orders'];
export const AdminMgmtExcludededRoutes = [ '/', '/me'];
